import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { Link, useParams } from 'react-router-dom'

import { explorarFuente, obtenerFuentes, type TipoListado } from '../api/consultas'
import Portada from '../componentes/Portada'

const PESTANAS: { tipo: TipoListado; texto: string }[] = [
  { tipo: 'POPULAR', texto: 'Popular' },
  { tipo: 'LATEST', texto: 'Reciente' },
]

export default function Fuente() {
  const { id = '' } = useParams()
  const [tipo, setTipo] = useState<TipoListado>('POPULAR')
  const [texto, setTexto] = useState('')
  const [busqueda, setBusqueda] = useState('')

  const { data: fuentes } = useQuery({ queryKey: ['fuentes'], queryFn: obtenerFuentes })
  const fuente = fuentes?.find((f) => f.id === id)

  const efectivo: TipoListado = busqueda ? 'SEARCH' : tipo

  const { data, isFetching, error } = useQuery({
    queryKey: ['fuente', id, efectivo, busqueda],
    queryFn: () => explorarFuente(id, efectivo, 1, busqueda || undefined),
    enabled: Boolean(id),
  })

  function buscar(e: React.FormEvent) {
    e.preventDefault()
    setBusqueda(texto.trim())
  }

  return (
    <>
      <Link to="/explorar" className="volver">
        ‹ Explorar
      </Link>
      <h1>{fuente?.name ?? 'Fuente'}</h1>
      <p className="subtitulo">{fuente ? `Idioma: ${fuente.lang}` : ''}</p>

      <form onSubmit={buscar} className="fila-busqueda">
        <input
          type="text"
          placeholder="Buscar en esta fuente…"
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
        />
        <button className="boton" type="submit">
          Buscar
        </button>
      </form>

      {busqueda ? (
        <p className="subtitulo">
          Resultados para «{busqueda}» ·{' '}
          <button
            className="enlace"
            onClick={() => {
              setBusqueda('')
              setTexto('')
            }}
          >
            limpiar
          </button>
        </p>
      ) : (
        <div className="pestanas">
          {PESTANAS.map((p) => (
            <button
              key={p.tipo}
              className={tipo === p.tipo ? 'pestana activa' : 'pestana'}
              onClick={() => setTipo(p.tipo)}
              disabled={p.tipo === 'LATEST' && fuente?.supportsLatest === false}
            >
              {p.texto}
            </button>
          ))}
        </div>
      )}

      {isFetching && <p className="cargando">Consultando la fuente…</p>}

      {error && (
        <div className="aviso error">
          <strong>La fuente no respondio</strong>
          <p>{(error as Error).message}</p>
          <p style={{ fontSize: 13, color: 'var(--texto-tenue)' }}>
            Suele ser temporal: la web original puede estar caida o limitando peticiones.
          </p>
        </div>
      )}

      {data && data.mangas.length === 0 && !isFetching && (
        <div className="aviso">Sin resultados.</div>
      )}

      {data && data.mangas.length > 0 && (
        <div className="rejilla">
          {data.mangas.map((manga) => (
            <Link key={manga.id} to={`/manga/${manga.id}`} className="tarjeta">
              <Portada ruta={manga.thumbnailUrl} titulo={manga.title} />
              <div className="titulo-tarjeta">{manga.title}</div>
            </Link>
          ))}
        </div>
      )}
    </>
  )
}
